import { render, staticRenderFns } from "./AboutPageIndicator.vue?vue&type=template&id=2be4a529&scoped=true&"
import script from "./AboutPageIndicator.vue?vue&type=script&lang=js&"
export * from "./AboutPageIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4a529",
  null
  
)

export default component.exports